import { requestLogout } from 'components/LogoutConfirm/LogoutConfirm';
import type React from 'react';
import { NavLink } from 'react-router';

import { RoleSwitcher } from 'components/Header/RoleSwitcher';
import { useProfileModeration } from 'hooks/useProfileModeration';
import { ChatReportMenuButton } from 'modules/ChatV2/components/ChatReportMenuButton';
import { ClipboardList, MessagesSquare, Settings, UserRound } from 'lucide-react';

import { DrawerLogo } from './DrawerLogo';
import styles from './MobileDrawer.module.scss';

interface StudentMobileNavProps {
  onNavigate?: () => void;
}

// Иконки - единый набор lucide, как в боковом меню (Figma «Кабинет ученика - Мои задачи»).
const menuItems = [
  { to: '/profile/tasks', label: 'Мои задачи', Icon: ClipboardList },
  { to: '/profile', label: 'Мой профиль', Icon: UserRound, end: true },
  { to: '/profile/chats', label: 'Мои чаты', Icon: MessagesSquare },
  { to: '/profile/settings', label: 'Настройки', Icon: Settings },
];

const secondaryItems = [
  { to: '/profile/questions', label: 'Частые вопросы' },
  { to: '/profile/help', label: 'Тех.поддержка' },
];

export const StudentMobileNav: React.FC<StudentMobileNavProps> = ({ onNavigate }) => {
  const { isApproved } = useProfileModeration();

  const handleLogout = () => {
    onNavigate?.();
    requestLogout();
  };

  return (
    <>
      <DrawerLogo accent='student' onNavigate={onNavigate} />
      <div className={styles.roleSwitcher}>
        <RoleSwitcher variant='menu' />
      </div>
      <ul className={styles.navList}>
        {menuItems.map(({ to, label, Icon, end }) => {
          const locked = to === '/profile/chats' && !isApproved;
          return (
          <li key={to} className={styles.navItem}>
            {locked ? (
              <div className={styles.navLocked}>
                <span className={styles.navLockedName}>
                  <Icon className={styles.navIcon} aria-hidden='true' />
                  {label}
                </span>
                <span className={styles.navLockedHint}>Доступно после одобрения профиля</span>
              </div>
            ) : (
            <NavLink
              to={to}
              end={end}
              onClick={onNavigate}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles['navLink--active'] : ''}`
              }
            >
              <Icon className={styles.navIcon} aria-hidden='true' />
              {label}
            </NavLink>
            )}
          </li>
          );
        })}
      </ul>
      <div className={styles.navDivider} />
      <ul className={`${styles.navList} ${styles.navListSecondary}`}>
        {secondaryItems.map(({ to, label }) => (
          <li key={to} className={styles.navItem}>
            <NavLink
              to={to}
              onClick={onNavigate}
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles['navLink--active'] : ''}`
              }
            >
              {label}
            </NavLink>
          </li>
        ))}
        <li className={styles.navItem}>
          <ChatReportMenuButton className={styles.navLink} onBeforeOpen={onNavigate} />
        </li>
        <li className={styles.navItem}>
          <button
            type='button'
            className={`${styles.navLink} ${styles.logoutButton}`}
            onClick={handleLogout}
          >
            Выход
          </button>
        </li>
      </ul>
    </>
  );
};
